module.exports = __webpack_public_path__ + "static/project-8d-a37dd35c9468f434f7a2cea9af5fb29d.png";